export default __webpack_public_path__ + "static/favicon-544596022a879c0b318699ccd261ba43.png";